import { useApp } from "../context/AppContext";
import { Phone, Mail, Instagram, MapPin } from "lucide-react";

export default function Contact() {
    const { lang } = useApp();
    return (
        <div data-testid="contact-page" className="pt-32 pb-24 max-w-[1400px] mx-auto px-6 lg:px-10">
            <div className="mb-14 max-w-2xl">
                <div className="overline mb-4">{lang === "ar" ? "تواصل معنا" : "Get in Touch"}</div>
                <h1 className="section-heading text-5xl md:text-6xl text-white">{lang === "ar" ? "نسعد بخدمتك" : "We'd love to hear from you"}</h1>
                <div className="hairline w-24 mt-6" />
            </div>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
                <ContactCard
                    icon={<Phone />}
                    label={lang === "ar" ? "واتساب" : "WhatsApp"}
                    value="+971 52 411 0193"
                    href="https://wa.me/971524110193"
                    testid="contact-whatsapp"
                />
                <ContactCard
                    icon={<Mail />}
                    label={lang === "ar" ? "البريد الإلكتروني" : "Email"}
                    value="uae.tent11@gmail.com"
                    href="mailto:uae.tent11@gmail.com"
                    testid="contact-email"
                />
                <ContactCard
                    icon={<Instagram />}
                    label="Instagram"
                    value="@sraa.tent"
                    href="https://instagram.com/sraa.tent"
                    testid="contact-instagram"
                />
                <ContactCard
                    icon={<MapPin />}
                    label={lang === "ar" ? "الموقع" : "Location"}
                    value={lang === "ar" ? "أبوظبي، الإمارات العربية المتحدة" : "Abu Dhabi, United Arab Emirates"}
                    testid="contact-location"
                />
            </div>
        </div>
    );
}

const ContactCard = ({ icon, label, value, href, testid }) => {
    const Tag = href ? "a" : "div";
    return (
        <Tag
            data-testid={testid}
            href={href}
            target={href?.startsWith("http") ? "_blank" : undefined}
            rel="noreferrer"
            className="luxury-card p-8 flex items-start gap-5 group"
        >
            <div className="text-[#D4AF37] mt-1 group-hover:scale-110 transition-transform">{icon}</div>
            <div>
                <div className="overline mb-1">{label}</div>
                <p className="text-white text-lg">{value}</p>
            </div>
        </Tag>
    );
};
